import { render, staticRenderFns } from "./LabelList.vue?vue&type=template&id=56364cca&scoped=true&lang=pug"
import script from "./LabelList.vue?vue&type=script&lang=js"
export * from "./LabelList.vue?vue&type=script&lang=js"
import style0 from "./LabelList.vue?vue&type=style&index=0&id=56364cca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56364cca",
  null
  
)

export default component.exports